export function getInspectorStyles(enabled: boolean) {
  return {
    button: {
      position: 'fixed' as const,
      right: 12,
      bottom: 12,
      zIndex: 2147483646,
      padding: '8px 12px',
      borderRadius: 6,
      border: '1px solid #888',
      background: enabled ? '#ffefc2' : '#f2f2f2',
      color: '#222',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      fontSize: 13,
      cursor: 'pointer',
      pointerEvents: 'auto' as const,
    },
    highlight: {
      position: 'absolute' as const,
      border: '2px solid #ff9800',
      background: 'rgba(255,152,0,0.08)',
      pointerEvents: 'none' as const,
      zIndex: 2147483645,
      display: 'none',
    },
    panel: {
      position: 'fixed' as const,
      left: 12,
      bottom: 12,
      zIndex: 2147483646,
      maxWidth: '50vw',
      background: '#111',
      color: '#eee',
      padding: '8px 12px',
      borderRadius: 6,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      fontSize: 12,
      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
      opacity: enabled ? 1 : 0.6,
      transition: 'opacity 0.2s',
    },
    copied: {
      color: '#4caf50',
      fontWeight: 600,
      marginLeft: 8,
      fontSize: 13,
      letterSpacing: '0.5px',
    },
    code: { color: '#8be9fd' },
    file: { color: '#a6e22e' },
  } as const;
}
